import { render } from "./CnfirmBoxCity.vue?vue&type=template&id=c3a5d3fa&scoped=true"
import script from "./CnfirmBoxCity.vue?vue&type=script&lang=js"
export * from "./CnfirmBoxCity.vue?vue&type=script&lang=js"

import "./CnfirmBoxCity.vue?vue&type=style&index=0&id=c3a5d3fa&scoped=true&lang=css"

import exportComponent from "/data/fe-node-modules/beta-ab/candao-h5-v6-phd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a5d3fa"]])

export default __exports__